// extracted by mini-css-extract-plugin
module.exports = {"blueBlock":"blueBlock_blueBlock__1x0IQ"};